<template>
  <div class="page flex-col">
    <PageHeader />

    <!-- 顶部通栏 -->
    <ChannelTopBar />

    <!-- 主体内容：1400px，左 1040px + 右 320px，间隔 40px -->
    <div class="channel-main flex-row">
      <!-- 左侧内容 -->
      <div class="channel-left flex-col">
        <!-- 轮播图：1040x370，固定4条记录 -->
        <div v-if="carouselItems.length > 0">
          <ChannelFourCarousel :items="carouselItems" />
        </div>

        <!-- 新闻列表（卡片 / 列表切换） -->
        <ChannelFourNews   v-if="carouselLoaded" :category-id="categoryId" :exclude-news-id-list="excludeNewsIdList" />
      </div>

      <!-- 右侧内容 -->
      <div class="channel-right flex-col">
        <!-- 杂志 -->
        <IssuePanel />

        <!-- 热点榜 -->
        <HotList />

        <!-- 广告位（动态） -->
        <div class="right-images flex-col">
          <a
            v-for="(ad, idx) in adList"
            :key="'ad-' + idx"
            :href="ad.turnUrl"
            target="_blank"
            class="right-ad-item"
          >
            <img
              class="right-ad-image"
              referrerpolicy="no-referrer"
              :src="ad.imageUrl"
              :alt="ad.textTip || '广告'"
            />
            <span v-if="ad.isShowTag === 1" class="ad-tag">广告</span>
          </a>
        </div>
      </div>
    </div>

    <PageFooter />

    <!-- ================= 回到顶部按钮 ================= -->
    <button 
      v-show="showBackToTop" 
      class="back-to-top" 
      @click="scrollToTop"
      title="回到顶部"
      aria-label="回到顶部"
    >
      <!-- 使用你提供的图片链接 -->
      <img 
        src="https://image.cbrand.com.cn/default/2026/10/2D3A47A40740459C98A490CF835B4529.png" 
        alt="回到顶部" 
        class="back-to-top-icon"
      />
    </button>
    <!-- =============================================== -->

  </div>
</template>

<script>
import PageHeader from '../detail/components/PageHeader.vue'
import PageFooter from '../detail/components/PageFooter.vue'
import IssuePanel from '../detail/components/IssuePanel.vue'
import HotList from '../detail/components/HotList.vue'
import { fetchAdDetails, resolveAdImage, fetchNewsListL2, mapNewsItem } from '../../api'
import ChannelTopBar from './components/ChannelTopBar.vue'
import ChannelFourCarousel from './components/ChannelFourCarousel.vue'
import ChannelFourNews from './components/ChannelFourNews.vue'

export default {
  name: 'ChannelFour',
  components: {
    PageHeader,
    PageFooter,
    IssuePanel,
    HotList,
    ChannelTopBar,
    ChannelFourCarousel,
    ChannelFourNews
  },
  data() {
    return {
      adList: [],
      categoryId: null,
      carouselItems: [],
      excludeNewsIdList: [],
      carouselLoaded: false, // 标记轮播数据是否加载完成
      
      // 新增：控制回到顶部按钮显示
      showBackToTop: false 
    }
  },
  // 新增：监听滚动事件
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  // 新增：组件销毁前移除监听，防止内存泄漏
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  created() {
    this.categoryId = this.$route.query.categoryId
    this.loadAds()
    // 使用 nextTick 确保轮播数据和排除列表都已准备好
    this.$nextTick(() => {
      this.loadCarousel()
    })
  },
  methods: {
    // 新增：处理滚动事件
    handleScroll() {
      // 当页面垂直滚动超过 300px 时显示按钮
      this.showBackToTop = window.scrollY > 300
    },
    // 新增：平滑回到顶部
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },
    async loadCarousel() {
      if (!this.categoryId) return
      try {
        const { list } = await fetchNewsListL2({
          categoryId: this.categoryId,
          isRecommended: 1,
          pageNum: 1,
          pageSize: 5
        })
        this.carouselItems = list.map(mapNewsItem)
        const idList = list.map(item => item.id).filter(Boolean)
        this.excludeNewsIdList = idList
        console.log('[ChannelFour] loadCarousel, excludeNewsIdList:', idList, 'total items:', list.length)
      } catch (e) {
        console.error('轮播数据加载失败', e)
      } finally {
        // 无论成功失败，都放开渲染，防止新闻列表永远不显示
        this.carouselLoaded = true
      }
    },
    async loadAds() {
      const list = await fetchAdDetails('cate_t4_hot_btm')
      this.adList = (list || []).map(item => ({
        imageUrl: resolveAdImage(item.imageUrl),
        turnUrl: item.turnUrl || '#',
        textTip: item.textTip || '广告',
        isShowTag: item.isShowTag
      }))
    }
  }
}
</script>

<style scoped>
.page {
  width: 1400px;
  margin: 0 auto;
  min-height: 100vh;
  background: #fff;
}

/* 主体内容容器 */
.channel-main {
  width: 1400px;
  margin: 0 auto;
  padding-top: 24px;
  padding-bottom: 40px;
  gap: 40px;
  align-items: flex-start;
}

/* 左侧内容区 */
.channel-left {
  width: 1040px;
  flex-shrink: 0;
}

/* 右侧内容区 */
.channel-right {
  width: 320px;
  flex-shrink: 0;
}

/* 右侧两张图片 */
.right-images {
  margin-top: 24px;
  gap: 16px;
}

.right-ad-item {
  display: block;
  width: 100%;
  position: relative;
}

.right-ad-image {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 4px;
}

.ad-tag {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 0 4px 0 4px;
  line-height: 1.5;
}

/* ================= 回到顶部按钮样式 ================= */
.back-to-top {
  position: fixed;    /* 固定定位，不受页面滚动影响 */
  bottom: 50px;       /* 距离屏幕底部 */
  right: 50px;        /* 距离屏幕右侧 */
  width: 54px;
  height: 54px;
  background-color: transparent; /* 背景透明，图片本身带有圆形 */
  border: none;                  /* 移除边框 */
  border-radius: 50%;            /* 圆形点击区域 */
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;                  /* 保证在最上层 */
  padding: 0;
  outline: none;
  transition: all 0.3s ease-in-out;
  /* 添加阴影让按钮更立体 */
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.15));
}

/* 按钮内部图片样式 */
.back-to-top-icon {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 保持图片比例 */
  display: block;
}

/* 鼠标悬停效果 */
.back-to-top:hover {
  transform: scale(1.1); /* 放大 */
  filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.25)); /* 阴影加深 */
}

/* 点击时的按压效果 */
.back-to-top:active {
  transform: scale(0.95); /* 缩小 */
}
</style>